import { ContentRangScore } from './ContentRangScore'

export const Level = ({ data, dataRange }) => {
  const arr = data.split(',').map(Number)
  const rangeScore = dataRange.filter((item) =>
    arr.includes(item?.scoreRangeId),
  )
  return <ContentRangScore data={rangeScore} />
}
